import { APPLY_LANGUAGE } from './language-provider.constants';
import { DEFAULT_LANGUAGE } from 'constants/locales';
import { ApplyLanguage } from './language-provider.actions';

export interface IState {
    readonly default: string;
    readonly activeLanguageCode: string;
}

export const initialState: IState = {
    default: DEFAULT_LANGUAGE,
    activeLanguageCode: DEFAULT_LANGUAGE
};

export const reducerKey = 'language' as const;

export const language = (state: IState = initialState, action: ApplyLanguage): IState => {
    switch (action.type) {
    case APPLY_LANGUAGE:
        return {
            default: DEFAULT_LANGUAGE,
            activeLanguageCode: action.payload
        };
    default:
        return state;
    }
};

export default language;
